export const CURRENCIES = {
    ETH: {
        balanceKey: 'eth',
        availableBalanceKey: 'eth_available',
        symbol: 'ETH',
        name: 'Ethereum',
        unitLabel: 'ETH',
        subtitle: 'Ethereum Mainnet',
        icon: '/assets/images/wallets/ethereum.svg',
        actions: {send: true},
        enabled: true,
        historyEnabled: true,
        balanceOrder: 0,
    },
    OWL: {
        balanceKey: 'owl',
        availableBalanceKey: 'owl_available',
        symbol: 'OWL',
        name: 'OWL Token',
        unitLabel: 'OWL',
        subtitle: 'ERC-20 / Ethereum Mainnet',
        icon: '/assets/images/wallets/owl.png',
        actions: {send: true},
        enabled: true,
        historyEnabled: true,
        balanceOrder: 2,
    },
    AUBE: {
        balanceKey: 'aube',
        availableBalanceKey: 'aube_available',
        symbol: 'AUBE',
        name: 'AUBE Coin',
        unitLabel: 'AUBE Coin',
        subtitle: 'ERC-20 / Ethereum Mainnet',
        icon: '/assets/images/wallets/aube.png',
        actions: {send: true},
        enabled: true,
        historyEnabled: true,
        balanceOrder: 1,
    },
};

export function enabledCurrencies() {
    return Object.keys(CURRENCIES)
        .filter((symbol) => CURRENCIES[symbol].enabled)
        .sort((a, b) => CURRENCIES[a].balanceOrder - CURRENCIES[b].balanceOrder);
}

export function historyEnabledCurrencies() {
    return Object.keys(CURRENCIES).filter((symbol) => CURRENCIES[symbol].historyEnabled);
}

export const ACTIVITY_TYPES = {
    RECEIVE: 'RECEIVE',
    SEND: 'SEND',
};

export const PURPOSE_TYPES = {
    STAKE: 'STAKE',
    UNSTAKE: 'UNSTAKE',
};
